import React, { ButtonHTMLAttributes, FC, MouseEventHandler } from 'react';
import Icon from '@/components/UI/icon/Icon';
import { IconNames } from '../../Types';
import styles from './Tab.module.scss';
interface TabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  value: string;
  isActive?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  icon?: IconNames;
  iconPosition?: 'start' | 'end';
  className?: string;
  data_cy?: string;
}
const Tab: FC<TabProps> = ({
  label,
  value,
  isActive,
  onClick,
  icon,
  iconPosition = 'start',
  className = '',
  data_cy,
  ...props
}) => {
  return <button {...props} className={`${styles['tab']} ${isActive ? styles['active'] : ''} ${className}`} onClick={onClick} value={value} data-cy={data_cy} data-sentry-component="Tab" data-sentry-source-file="Tab.tsx">
      {iconPosition === 'start' && <Icon name={icon as IconNames} type={'inherit'} size={'medium'} />}
      {label}
      {iconPosition === 'end' && <Icon name={icon as IconNames} type={'inherit'} size={'medium'} />}
    </button>;
};
export default Tab;